import Axios from "axios";
const BASEURL = "https://dajoo-5cec58e7f249.herokuapp.com";
// const BASEURL = "http://localhost:8080";
export const baseUrl = BASEURL;

const getAccessToken = () => {
  return localStorage.getItem("accessToken");
};

export const postData = (route, data) => {
  return new Promise((resolve, reject) => {
    const token = getAccessToken(); // ✅ Fresh token
    Axios.post(baseUrl + route, data, {
      headers: {
        // ✅ Bearer prefix add karein
        Authorization: token ? `${token}` : "",
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const uploadData = (route, formData, token) => {
  return new Promise((resolve, reject) => {
    Axios.post(baseUrl + route, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        // ✅ Agar token function mein pass hua hai, use karein, warna localStorage se lein
        Authorization: token ? `${token}` : `${getAccessToken()}`,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const getData = (route, params = {}) => {
  return new Promise((resolve, reject) => {
    const token = getAccessToken(); // ✅ Fresh token
    const queryString = new URLSearchParams(params).toString();
    const url = queryString
      ? `${baseUrl}${route}?${queryString}`
      : `${baseUrl}${route}`;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // ✅ Bearer prefix + Fresh token
        ...(token ? { Authorization: `${token}` } : {}),
      },
    })
      .then((response) => response.json())
      .then((data) => resolve(data))
      .catch((error) => {
        console.error("Error in GET API:", error);
        reject(error);
      });
  });
};

export const getDataText = (route, params = {}) => {
  return new Promise((resolve, reject) => {
    const token = getAccessToken();
    const queryString = new URLSearchParams(params).toString();
    const url = queryString
      ? `${baseUrl}${route}?${queryString}`
      : `${baseUrl}${route}`;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "text/html",
        ...(token ? { Authorization: ` ${token}` } : {}),
      },
    })
      .then((response) => response.text())
      .then((data) => resolve(data))
      .catch((error) => {
        console.error("Error in GET TEXT API:", error);
        reject(error);
      });
  });
};
